export class ResetState {
    public static readonly type = '[RootState] Reset state';
}
